/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
module.exports = {
  cs: require('./cs.json'),
  da: require('./da.json'),
  de: require('./de.json'),
  en: require('./en.json'),
  es: require('./es.json'),
  fi: require('./fi.json'),
  fr: require('./fr.json'),
  hu: require('./hu.json'),
  it: require('./it.json'),
  ja: require('./ja.json'),
  ko: require('./ko.json'),
  nb: require('./nb.json'),
  nl: require('./nl.json'),
  pl: require('./pl.json'),
  pt: require('./pt.json'),
  ru: require('./ru.json'),
  sv: require('./sv.json'),
  tr: require('./tr.json'),
  uk: require('./cs.json'),
  'zh-hans': require('./zh-Hans.json'),
  'zh-hant': require('./zh-Hant.json'),
  zu: require('./zu.json')
};
